import { IProject } from "integrations/firebase/collections";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useAnalytics } from "contexts/AnalyticsContext";
import { TabHeader } from "components/TabHeader";
import { ProjectsTable } from "components/projectsTable/ProjectsTable";

export const ProjectsPage = () => {
  const { t } = useTranslation("projects");
  const navigate = useNavigate();
  const { gaEvent } = useAnalytics();

  const handleTabProjectsGoToDetails = (row: IProject) => {
    navigate({ to: "/projects/$projectId", params: { projectId: row.id } });
    gaEvent({
      type: "view_item_list",
      payload: {
        item_list_name: row.name,
        item_list_id: row.id,
        item_category: "project",
      },
    });
  };

  return (
    <div>
      <TabHeader
        title={t("projects:projects.header.title")}
        subtitle={t("projects:projects.header.subtitle")}
      />
      <ProjectsTable onRowClicked={handleTabProjectsGoToDetails} />
    </div>
  );
};
